import styled from 'styled-components';
export const BaseContainer = styled.div`
`;

export const FixedWidthContainer = BaseContainer.extend`
  max-width: 960px;
  margin: 0 auto;
`
export const FrameContainer = FixedWidthContainer.extend`
  padding: 1.0875rem;
`



// WEBPACK FOOTER //
// ./src/styledComponents/layout.js